<div class="row">
  <div class="col-12">
    @if (isSpouse === false) {
      <h2 id="information-sur-lentrepreneur">Informations sur l'entrepreneur</h2>
    }
    @if (isSpouse === true) {
      <h2 id="information-sur-le-conjoint">Informations sur le conjoint</h2>
    }

    <div class="row">
      <div class="col-6 col-lg-2">
        <magieno-input-text-field
        [advancedFormControl]="this.incomeTaxPersonalSpouseForm.formElements.lastName | asAdvancedFormControl"></magieno-input-text-field>
      </div>

      <div class="col-6 col-lg-2">
        <magieno-input-text-field
        [advancedFormControl]="this.incomeTaxPersonalSpouseForm.formElements.firstName | asAdvancedFormControl"></magieno-input-text-field>
      </div>
    </div>

    <magieno-datepicker
    [advancedFormControl]="this.incomeTaxPersonalSpouseForm.formElements.birthdate | asAdvancedFormControl">
      <i class="fas fa-calendar" calendarIcon></i>
    </magieno-datepicker>


    @if (isSpouse === false) {
      <magieno-boolean-select
      [advancedFormControl]="incomeTaxPersonalForm.formElements.isMarried | asAdvancedFormControl"></magieno-boolean-select>
    }
  </div>
</div>

<div class="row mt-5">
  <div class="col-12">
    @if (isSpouse === false) {
      <h2 id="revenus-de-entrepreneur">Revenus de l'entrepreneur</h2>
    }
    @if (isSpouse === true) {
      <h2 id="revenus-du-conjoint">Revenus du conjoint</h2>
    }

    <magieno-input-money-field
      [advancedFormControl]="this.incomeTaxPersonalSpouseForm.formElements.employmentIncome | asAdvancedFormControl"
      [currency]="this.currency"
    [locale]="this.locale"></magieno-input-money-field>

    <magieno-boolean-select
    [advancedFormControl]="this.incomeTaxPersonalSpouseForm.formElements.isEmployeeSubjectToEI | asAdvancedFormControl"></magieno-boolean-select>

    <magieno-input-money-field
      [advancedFormControl]="this.incomeTaxPersonalSpouseForm.formElements.realEligibleDividend | asAdvancedFormControl"
      [currency]="this.currency"
    [locale]="this.locale"></magieno-input-money-field>

    <magieno-input-money-field
      [advancedFormControl]="this.incomeTaxPersonalSpouseForm.formElements.realNonEligibleDividend | asAdvancedFormControl"
      [currency]="this.currency"
    [locale]="this.locale"></magieno-input-money-field>

    <magieno-input-money-field
      [advancedFormControl]="this.incomeTaxPersonalSpouseForm.formElements.gainPubliclyTradeShares | asAdvancedFormControl"
      [currency]="this.currency"
    [locale]="this.locale"></magieno-input-money-field>

    <magieno-input-money-field
      [advancedFormControl]="this.incomeTaxPersonalSpouseForm.formElements.othersIncomesLine13000 | asAdvancedFormControl"
      [currency]="this.currency"
    [locale]="this.locale"></magieno-input-money-field>

  </div>
</div> <!-- / .row -->

<div class="row mt-5">
  <div class="col-12">
    @if (isSpouse === false) {
      <h2 id="credits-deductions-entrepreneur">Crédits et déductions de l'entrepreneur</h2>
    }
    @if (isSpouse === true) {
      <h2 id="credits-deductions-conjoint">Crédits et déductions du conjoint</h2>
    }

    <magieno-input-money-field [advancedFormControl]="federalForm.formElements.paidContributionRRSP | asAdvancedFormControl"
      [currency]="this.currency"
    [locale]="this.locale"></magieno-input-money-field>

    @if (isSpouse === true) {
      <magieno-input-money-field
        [advancedFormControl]="federalForm.formElements.maximumAllowedDeductibleContributionsRRSP | asAdvancedFormControl"
        [currency]="this.currency"
      [locale]="this.locale"></magieno-input-money-field>
    }

    <magieno-boolean-select
    [advancedFormControl]="this.incomeTaxPersonalSpouseForm.formElements.isEligibleToCWB | asAdvancedFormControl"></magieno-boolean-select>

  </div>
</div> <!-- / .row -->



